<template>
  <div class="loggedout-step text-center">
    <div class="step-inner mx-auto">
      <img
        :src="require(`@/assets/images/decorator-${step.image}.png`)"
        :alt="step.title"
        class="step-image mb-4"
      />
      <h3 class="step-title mb-2">{{ step.title }}</h3>
      <p class="step-text" v-html="step.text"></p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoggedOutStepCard',
  props: {
    step: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped>
.step-inner {
  max-width: 320px;
}
.step-image {
  width: 100%;
  height: 300px;
  object-fit: contain;
}
.step-title {
  font-family: 'DM Sans', sans-serif;
  font-weight: 800;
  font-size: 24px;
  line-height: 32px;
  letter-spacing: 0px;
}
.step-text {
  font-family: 'DM Sans', sans-serif;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.15px;
}
</style>
